import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customDate'
})
export class CustomDatePipe implements PipeTransform {

  constructor(private datePipe: DatePipe) {}

  transform(value: string | Date): string {
    if (!value) return '';

    let date: Date;

    if (value instanceof Date) {
      // Ya viene como Date
      date = value;
    } else if (value.includes('T')) {
      // Caso ISO: "2025-08-20T00:00:00"
      date = new Date(value);
    } else if (value.includes('/')) {
      // Caso dd/MM/yyyy
      const [day, month, year] = value.split('/');
      date = new Date(+year, +month - 1, +day);
    } else {
      // Si no encaja en nada, lo intentamos parsear directo
      date = new Date(value);
    }

    const day = this.datePipe.transform(date, 'd');
    const month = this.datePipe.transform(date, 'MMMM');
    const year = this.datePipe.transform(date, 'yyyy');

    return `${day} de ${month} del ${year}`;
  }

}
